import Modal from "../../../components/Modal";
import ModalWrapper from "../../../components/ModalWrapper";
import { Trans } from "@lingui/macro";
import { AutoColumn } from "../../../components/Column";
import { useCallback, useMemo, useEffect, useState } from "react";
import styled from "styled-components";
import NumericalInput from "../../../components/NumericalInput";
import AddressInput from "../../../components/AddressInput";
import TextInput from "../../../components/TextInput";
import MultiSelect from "../../../components/MultiSelect";
import Row from "../../../components/Row";
import useERC20Allowance from "../../../hooks/useERC20Allowance";
//import { MINI_POOL_ADDRESS } from "../../../constants/address";

import { GROUPAPP_ADDRESS } from "../../../constants/address";
import useERC20Approve from "../../../hooks/useERC20Approve";
import { useWallet } from "use-wallet";

import { ButtonLight, ButtonPrimary } from "../../../components/Button";
import Loader from "../../../components/Loader";
import useERC20Balance from "../../../hooks/useERC20Balance";
import { fromAmount, toAmount } from "../../../utils/amount";
import { ZERO_ADDRESS } from "../../../utils/ethereum";
import { BusinessTypeA, AppTypeA } from "../../../constants/dict";

const InputNumerical = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;

const InputText = styled(TextInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const InputAddress = styled(AddressInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const LabelWrapper = styled.div`
  font-size: 14px;
`;

const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  font-size: 14px;
`;

function PkgPurchaseModal({
  isOpen,
  setIsOpen,
  appMinPledge,
  appgroupOpt,
  token,
  pkgitem,
}) {
  const { account, chainId } = useWallet();

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [appid, setAppid] = useState((pkgitem && pkgitem.appid) || 0);

  const [apptypeid, setApptypeid] = useState(
    (pkgitem && pkgitem.apptypeid) || 1
  );
  const [businesstype, setBusinesstype] = useState(
    (pkgitem && pkgitem.businesstype) || 1
  );
  const [merchantid, setMerchantid] = useState(
    (pkgitem && pkgitem.merchantid) || 0
  );
  const [profitrate, setProfitrate] = useState(
    (pkgitem && pkgitem.profitrate) || 0
  );
  const [name, setName] = useState((pkgitem && pkgitem.name) || "");
  const [funs, setFuns] = useState((pkgitem && pkgitem.funs) || "");
  const [desc, setDesc] = useState((pkgitem && pkgitem.desc) || "");
  const [minPledge, setMinPledge] = useState("");
  const [owneraddr, setOwneraddr] = useState(
    (pkgitem && pkgitem.owneraddr) || account
  );
  const [ext, setExt] = useState((pkgitem && pkgitem.ext) || "");

  const tokenContract = useMemo(() => {
    if (token) {
      return token.contract;
    }
    return null;
  }, [token]);

  const balance = useERC20Balance(tokenContract, account);
  const [allowance, fetchAllowance] = useERC20Allowance(
    tokenContract,
    account,
    GROUPAPP_ADDRESS[chainId]
  );

  const [onApprove, approveLoading] = useERC20Approve(
    tokenContract,
    GROUPAPP_ADDRESS[chainId]
  );

  useEffect(() => {
    if (token) {
      fetchAllowance();
      setValue(toAmount(appMinPledge || 0, (token && token.decimals) || 18));
      setMinPledge(
        toAmount(
          (pkgitem && pkgitem.minPledge) || 0,
          (token && token.decimals) || 18
        )
      );

      if (!pkgitem) setOwneraddr(account);
    }
  }, [
    account,
    tokenContract,
    token,
    setValue,
    appMinPledge,
    appgroupOpt.AppGroupContract,
    fetchAllowance,
    pkgitem,
  ]);

  const handleOnApprove = useCallback(async () => {
    await onApprove(fromAmount(value || 0, token.decimals || 18));
    await fetchAllowance();
  }, [fetchAllowance, onApprove, value, token]);

  const handleOnPledge = useCallback(async () => {
    //console.log("getToken",await appgroupOpt.getToken());
    // getNodeInfo
    const tx = await appgroupOpt.updateApps(
      fromAmount(value || 0, token.decimals || 18),
      appid,
      apptypeid,
      businesstype,
      merchantid,
      profitrate,
      name,
      funs,
      desc,
      fromAmount(minPledge || 0, token.decimals || 18),
      owneraddr ? owneraddr : ZERO_ADDRESS, //todo
      ext,
      setLoading,
      token.address == ZERO_ADDRESS ? false : true
    );
    console.log(tx);
  }, [
    appid,
    apptypeid,
    businesstype,
    desc,
    funs,
    ext,
    merchantid,
    minPledge,
    name,
    appgroupOpt,
    owneraddr,
    profitrate,
    token,
    value,
  ]);

  return (
    <Modal isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
      <ModalWrapper
        title={
          <>
            <Trans>Create App</Trans> {pkgitem && pkgitem.appid ? appid : ""}{" "}
          </>
        }
        toggleWalletModal={() => setIsOpen(false)}
      >
        <AutoColumn gap={"24px"}>
          <AutoColumn gap={"sm"}>
            {(!appid || appid == "0") && (
              <>
                <LabelWrapper>
                  <Trans>Pledge Amount</Trans>
                </LabelWrapper>

                <Row>
                  <InputNumerical value={value} onUserInput={setValue} />
                  <Symbol>{token && token.symbol}</Symbol>
                </Row>

                <BalanceWrapper>
                  <Trans>
                    Balance:{" "}
                    {toAmount(balance, (token && token.decimals) || 18).toFixed(
                      6,
                      0
                    )}
                  </Trans>{" "}
                  {token && token.symbol}
                </BalanceWrapper>
              </>
            )}

            <LabelWrapper>
              <Trans>name</Trans>
            </LabelWrapper>
            <InputAddress value={name} onUserInput={setName} />

            <LabelWrapper>
              <Trans>apptypeid</Trans>
            </LabelWrapper>
            <MultiSelect
              List={AppTypeA}
              selectValue={apptypeid}
              onUserInput={setApptypeid}
            />

            <LabelWrapper>
              <Trans>businesstype</Trans>
            </LabelWrapper>
            <MultiSelect
              List={BusinessTypeA}
              selectValue={businesstype}
              onUserInput={setBusinesstype}
            />

            {/* <LabelWrapper>
              <Trans>merchantid</Trans>
            </LabelWrapper>
            <InputText value={merchantid} onUserInput={setMerchantid} /> */}

            {/* <LabelWrapper>
              <Trans>profitrate</Trans>
            </LabelWrapper>
            <InputAddress value={profitrate} onUserInput={setProfitrate} /> */}
            <LabelWrapper>
              <Trans>funs</Trans>
            </LabelWrapper>
            <InputText value={funs} maxLength={3000} onUserInput={setFuns} />
            <LabelWrapper>
              <Trans>desc</Trans>
            </LabelWrapper>
            <InputText value={desc} onUserInput={setDesc} />

            <LabelWrapper>
              <Trans>minPledge</Trans>
            </LabelWrapper>
            <InputNumerical value={minPledge} onUserInput={setMinPledge} />

            <LabelWrapper>
              <Trans>owneraddr</Trans>
            </LabelWrapper>
            <InputAddress value={owneraddr} onUserInput={setOwneraddr} />

            {/* <LabelWrapper>
              <Trans>ext</Trans>
            </LabelWrapper>
            <InputAddress value={ext} onUserInput={setExt} /> */}
          </AutoColumn>
          {allowance.lt(appMinPledge || 0) && (!appid || appid == 0) ? (
            <ButtonLight disabled={approveLoading} onClick={handleOnApprove}>
              {approveLoading ? <Loader /> : <Trans>Approve</Trans>}
            </ButtonLight>
          ) : (
            <ButtonPrimary
              onClick={handleOnPledge}
              disabled={loading || !appMinPledge}
            >
              {loading && <Loader />} <Trans>Pledge and Create App</Trans>
            </ButtonPrimary>
          )}
        </AutoColumn>
      </ModalWrapper>
    </Modal>
  );
}

export default PkgPurchaseModal;
